export enum Domain {
    Ru = 'ru',
    Kz = 'kz',
    By = 'by',
    Ua = 'ua',
    Com = 'com',
    ComTr = 'com.tr',
    Uz = 'uz'
}
